import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { RiskAssessmentCard } from '~/components/RiskAssessmentCard';
import { useClaim } from '~/features/claimReview/ClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export default function ClaimRiskAssessment() {
  const claim = useClaim();
  const storeId = useStoreId();

  const { data: riskAssessment, isPending } = useQuery({
    queryKey: ['claim-risk', storeId, `${claim.id}`],
    queryFn: () => api.store(storeId).claim(`${claim.id}`).risk(),
  });

  return (
    <RiskAssessmentCard riskAssessment={riskAssessment} isPending={isPending} />
  );
}
